{
    "GenericAdminFilterLanguage_CME_LABEL": "CME",
    "GenericAdminFilterLanguage_TELSYS_LABEL": "Servidor de Telefonia",
    "GenericAdminFilterLanguage_PARTITION_LABEL": "Partição",
    "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "Tipo de CRM",
    "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Incluir itens CME filhos",
    "GenericAdminFilterLanguage_SEARCH_LABEL": "Procurar",
    "NAME": "GenericAdminFilterLanguage",
    "GenericAdminFilterLanguage_OPTION_ALL_LABEL": "Todos",
    "GenericAdminFilterLanguage_OPTION_ANY_LABEL": "Qualquer",
    "GenericAdminFilterLanguage_OPTION_NONE_LABEL": "Nenhum",
    "GenericAdminFilterLanguage_PLEASE_SELECT_OPTION_TO_SHOW_RESULTS": "Selecione uma opção para exibir os resultados."
}